<template>
  <div class="content-view">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-lg-6">

          <b-card
            class="mt-3"
            v-if="verificationResult != null"
          >

            <div class="row mb-5">
              <div class="col-12">
                <div v-if="verificationResult === ''">Deklaracja o&nbsp;wskazanych parametrach nie istnieje w bazie CEEB. Jeżeli złożyłeś deklarację w formie papierowej do właściwego urzędu gminy/miasta skontaktuj się z właściwym urzędem. Pamiętaj, że pracownik urzędu ma 30&nbsp;dni na wprowadzenie Twojej deklaracji do bazy CEEB w przypadku źródeł ciepła/spalania paliw, które uruchomione zostały po 1.07.2021&nbsp;r. oraz 6&nbsp;miesięcy w&nbsp;przypadku źródeł ciepła/spalania paliw, które uruchomione zostały przed 1.07.2021&nbsp;r.</div>
                <div v-if="verificationResult !== ''">Deklaracja dla wskazanego punktu adresowego została złożona do bazy CEEB.<br /><br />
                Jeżeli deklaracja została złożona w formie elektronicznej i chcesz wydrukować jej potwierdzenie, zaloguj się ponownie na swoje Konto użytkownika z wykorzystaniem login.gov.pl: <a href="https://zoneapp.gunb.gov.pl/wk/login">Logowanie do bazy CEEB</a> i pobierz PDF deklaracji. Jeżeli posiadasz unikalny numer deklaracji, możesz również wpisać go w wyszukiwarkę obok i wygenerować PDF z deklaracją.<br /><br />
                Jeżeli deklaracja została złożona w formie papierowej i posiadasz jej unikalny numer, wpisz go wyszukiwarkę obok, aby wygenerować plik PDF. Jeżeli nie posiadasz unikalnego numeru deklaracji, skontaktuj się z właściwym urzędem gminy/miasta, do którego składana była deklaracja.</div>
              </div>
            </div>

            <div class="buttons-row">
              <button
                type="button"
                class="btn btn-primary mr-3"
                @click="closeDeclarationVerification"
              >
                Sprawdź kolejny adres
              </button>
            </div>

          </b-card>

          <b-card
            class="mt-3"
            v-if="verificationResult == null"
          >
            <b-card-text>
              <div class="mb-3"><strong>Czy deklaracja dla Twojego punktu adresowego została zgłoszona do bazy CEEB?</strong></div>
              <div class="forms">
                <div class="row">
                  <div class="col-12">
                    <InputDropdown :items="voivodeships" v-model="voivodeship" placeholder="Województwo" :class="{'error': errors.includes('voivodeship')}" />
                  </div>
                  <div class="col-12">
                    <InputDropdown ref="countyInput" :items="counties" v-model="county" placeholder="Powiat" :class="{'error': errors.includes('county')}" />
                  </div>
                  <div class="col-12">
                    <InputDropdown ref="communityInput" :items="communities" v-model="community" placeholder="Gmina" :class="{'error': errors.includes('community')}" />
                  </div>
                  <div class="col-12 col-md-8">
                    <InputDropdown ref="cityInput" :items="cities" v-model="city" placeholder="Miejscowość" :class="{'error': errors.includes('city')}" />
                  </div>
                  <div class="col-12 col-md-4">
                    <input v-mask="'##-###'" v-model="postalCode" class="text-input postal-code-input"  :class="{'error': errors.includes('postalCode')}"
                          placeholder="Kod pocztowy"/>
                  </div>

                  <div v-show="customStreetEntrance && (!hasNoStreets)" class="col-8" style="min-height: 64px;">
                    <input v-model="customStreetName" type="text"
                            :class="{'error':  errors.includes('street'), 'text-input': true, 'street-input': true}"
                          aria-label="Niestandardowa nazwa ulicy" placeholder="Niestandardowa nazwa ulicy"/>
                  </div>
                  <div v-show="(!customStreetEntrance) && (!hasNoStreets)" class="col-12 col-md-8">
                    <InputDropdown
                      ref="streetInput"
                      :class="{'error': errors.includes('street'), 'street-input': true}"
                      :items="streets"
                      v-model="street"
                      placeholder="Ulica"/>
                  </div>
                  <div v-show="hasNoStreets" class="col-8" style="min-height: 64px;">
                    &nbsp;
                  </div>

                  <div class="col-12 col-md-4" v-show="customNumberEntrance">
                    <input
                      v-model="customNumber"
                      type="text"
                      :class="{'error': errors.includes('number'), 'text-input': true, 'building-input': true}"
                      aria-label="Numer budynku"
                      placeholder="Wpisz numer budynku"
                    />

                  </div>
                  <div
                    class="col-12 col-md-4"
                    v-show="!customNumberEntrance"
                  >
                    <InputDropdown
                      ref="numberInput"
                      class="street-input"
                      :items="numbers"
                      v-model="number"
                      :class="{'error': errors.includes('number'), 'street-input': true}"
                      placeholder="Wybierz numer budynku"
                    />
                  </div>


                  <div class="col-12">

                    <label for="custom_street_checkbox" v-show="(!hasNoStreets)">
                      <input type="checkbox" id="custom_street_checkbox" v-model="customStreetEntrance">
                      Nie znalazłeś swojej ulicy, wpisz ją ręcznie
                      <span class="checkmark"></span>
                    </label><br />

                    <label for="custom_number_checkbox">
                      <input type="checkbox" id="custom_number_checkbox" v-model="customNumberEntrance">
                      Nie znalazłeś numeru swojego budynku, wpisz go ręcznie
                      <span class="checkmark"></span>
                    </label><br />

                    <label for="has_no_streets">
                      <input type="checkbox" id="has_no_streets" v-model="hasNoStreets">
                      W deklaracji nie wskazano ulicy
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>

                <div class="buttons-row">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="verifyDeclarationForAddress"
                    :disabled="inProgress"
                  >
                    Sprawdź
                  </button>
                  &nbsp;
                  <b-spinner v-if="inProgress" label="Wczytuję"></b-spinner>
                </div>

              </div>
            </b-card-text>
          </b-card>
        </div>

        <div class="col-12 col-lg-6" v-if="verificationResult == null">

          <b-card class="mt-3">
            <b-card-text>
              <div class="row mb-3">
                <div class="col-12">
                  <strong>Wpisz unikalny numer deklaracji aby pobrać ją w formacie PDF</strong>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <input
                    class="text-input"
                    type="text"
                    v-model="textid"
                    placeholder="Unikalny numer deklaracji"
                    :class="{'error': pdfErrors.includes('textid')}"
                  />
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-12">
                  <input
                    class="text-input"
                    type="text"
                    v-model="name"
                    placeholder="E-mail lub imię i nazwisko wypełniającego lub nazwa instytucji/firmy"
                    :class="{'error': pdfErrors.includes('name')}"
                  />
                </div>
              </div>

              <div class="buttons-row">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="downloadPdf"
                    :disabled="inTextidProgress"
                  >
                    Pobierz PDF
                  </button>
                  &nbsp;
                  <b-spinner v-if="inTextidProgress" label="Wczytuję"></b-spinner>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </div>
    </div>

    <div v-show="(revCode != null)">
      <div class="around-fade"></div>

      <div class="zone-modal">
        <CloseModalButton :on-click="closeRevModal"></CloseModalButton>
        <h1>Deklaracja jest nieaktualna</h1>
        <p>
          Aktualną wersję deklaracji złożono dnia {{ revDate }} i ma ona identyfikator:<br />
          {{ revTextId }}
        </p>
        <p>
          Kliknij poniżej, aby sprawdzić deklarację w aktualnej wersji.
        </p>
        <div style="text-align: right; padding-top: 0.5em">
          <button type="button" class="btn btn-link" @click="closeRevModal">
            Zamknij
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="showCurrentVersion"
          >
            Przejdź do aktualnej wersji
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import InputDropdown from "@/components/common/InputDropdown";
import LocationsModel from "@/models/locations";
import DeclarationsModel from "@/models/declarations";
import PolishAddress from "@/mixins/PolishAddress";
import CloseModalButton from "@/components/common/CloseModalButton";


import { Base64 } from 'js-base64';

export default {
  name: "Verification",
  mixins: [PolishAddress],
  components: {InputDropdown, CloseModalButton},

  data() {
    return {
      saveButtonLock: false,
      errors: [],
      verificationResult: null,
      inProgress: false,
      hasNoStreets: false,
      textid: null,
      inTextidProgress: false,
      name: null,
      pdfErrors: [],
      revTextId: null,
      revCode: null,
      revDate: null
    }
  },

  methods: {
    closeDeclarationVerification() {
      this.verificationResult = null;
      this.voivodeship = null;
      this.county = null;
      this.community = null;
      this.city = null;
      this.postalCode = null;
      this.street = null;
      this.number = null;
      this.customStreetEntrance = null;
      this.customNumberEntrance = null;
      this.hasNoStreets = false;
    },

    verifyDeclarationForAddress() {
      let _errors  = [];

      if ((!this.voivodeship) || (!this.voivodeship.id))
          _errors.push('voivodeship');
      if ((!this.county) || (!this.county.id))
          _errors.push('county');
      if ((!this.community) || (!this.community.id))
          _errors.push('community');
      if ((!this.city) || (!this.city.id))
          _errors.push('city');
      if ((!this.postalCode) || (!this.postalCode.length))
          _errors.push('postalCode');
      if (this.hasNoStreets) {
        if ((!this.customNumberEntrance) && ((!this.number) || (!this.number.id)))
          _errors.push('number');
      } else {
        if (!((this.customStreetEntrance) && (this.customNumberEntrance))) {
            if ((!this.customStreetEntrance) && ((!this.street) || (!this.street.id)))
                _errors.push('street');
            if ((!this.customNumberEntrance) && ((!this.number) || (!this.number.id)))
                _errors.push('number');
        }
      }

      this.errors = _errors;

      if (_errors.length) {
        this.$notify({
          group: 'zone',
          type: 'error',
          title: 'Błąd!',
          text: 'Nie wszystkie wymagane pola zostały wypełnione'
        });
        return;
      }

      let payload = {
        postal_code: this.postalCode,
        city_id: this.city.id
      };

      if ((this.customStreetEntrance) || (this.hasNoStreets)) {
        payload.custom_street_name = '' + this.customStreetName;
      } else {
        payload.street_id = this.street.id;
      }

      if (this.customNumberEntrance) {
        payload.custom_number = this.customNumber;
      } else {
        payload.number_id = this.number.id;
      }

      this.inProgress = true;
      DeclarationsModel.verifyDeclarationForAddress(payload).then((res) => {
        if (!res.data.result.length) {
          this.verificationResult = '';
        } else {
          var arr = res.data.result.split('|');
          this.verificationResult = {
            'date': arr[0],
            'type': arr[1]
          };
        }
        this.inProgress = false;
      });
    },

    downloadPdf() {
      let _errors  = [];

      if (!this.textid)
          _errors.push('textid');
      if (!this.name)
          _errors.push('name');

      this.pdfErrors = _errors;

      if (_errors.length) {
        this.$notify({
          group: 'zone',
          type: 'error',
          title: 'Błąd!',
          text: 'Należy wypełnić wszystkie pola'
        });
        return;
      }

      var payload = {
        'textid': this.textid,
        'name': this.name
      }
      var encoded = Base64.encode(JSON.stringify(payload)).replace('/', '-');
      this.inTextidProgress = true;
      DeclarationsModel.getDeclarationIdByTextid(encoded).then((res) => {
        this.inTextidProgress = false;
        if (res.data.result) {
          window.location = '/api/declarations/pdf/x' + encoded;
        } else if (res.data.revcode) {
          this.revTextId = res.data.revuid;
          this.revCode = res.data.revcode;
          this.revDate = res.data.revdate;
        } else {
          this.$notify({
            group: 'zone',
            type: 'error',
            title: 'Błąd!',
            text: 'Wpisywane dane różnią się od tych, które zostały uzupełnione w deklaracji.'
          });
        }
      });
    },

    closeRevModal() {
      this.revTextId = null;
      this.revCode = null;
    },

    showCurrentVersion() {
      var jsondata = Base64.decode(this.revCode);
      var data = JSON.parse(jsondata);
      this.textid = data.textid;
      this.name = data.name;
      this.revTextId = null;
      this.revCode = null;
    }
  },

  computed: {
    address() {
      var str = this.city.name + ' ' + this.postalCode;
      if (this.customStreetName)
        str += ', ' + this.customStreetName;
      else if (this.street && ('name' in this.street))
        str += ', ' + this.street.name;
      if (this.customNumber)
        str += ' ' + this.customNumber;
      else if (this.number && ('name' in this.number))
        str += ' ' + this.number.name;
      return str;
    }
  },

  mounted() {
    if (('nr' in this.$route.query) && (this.$route.query.nr)) {
      this.textid = this.$route.query.nr;
    }
  }
}
</script>

<style scoped>
.btn {
  margin-bottom: 0.5em;
}
a.pure-link { color: #202f64 }

.btn-primary:disabled {
  background-color: #202f64;
  opacity: 0.5;
  cursor: not-allowed;
}

.radios label.error {
  color: #f10;
}

.zone-modal {
  height: 16rem;
}

@media screen and (max-width: 768px) {
  .zone-modal {
    -webkit-transform: none;
    transform: none;
    position: absolute;
    top: -80px;
    left: 10px;
    right: 10px;
    height: auto;
    width: auto;
  }

  .zone-modal .postal-code-input {
    margin-bottom: 0.8rem;
  }
}

.zone-modal .buttons-row {
  margin-top: 0;
}
</style>
